<template>
  <div id="app">
    <AlertLGPD @accept="hideLgpdAlert = true" v-if="!getLgpd && !hideLgpdAlert"/>
    <MessageModal v-if="showMessageModal"
                  :styleMessage="styleMessageModal"
                  :title="titleMessageModal"
                  :message="messageModal"/>
    <MessageSnackbar :message="messageSnackbar" v-if="showMessageSnackbar"/>
    <div v-if="loading" class="loadingBackground">
      <img v-if="parceiro || getSubdominio && parceiroConfig.logo != null" :src="parceiroConfig.logo"/>
      <img v-else-if="!getSubdominio" src="./assets/images/logo.png">
      <LoadingMessage :message="loadingMessage"/>
      <div class="loader"/>
    </div>
    <router-view/>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import MessageModal from "./components/MessageModal";
  import MessageSnackbar from "./components/MessageSnackbar";
  import LoadingMessage from "./components/LoadingMessage";
  import AlertLGPD from "./components/AlertLGPD";
  export default {
    name: 'App',
    components: {AlertLGPD, MessageSnackbar, MessageModal, LoadingMessage},
    data(){
      return{
        hideLgpdAlert: false,
      }
    },
    computed:{
        ...mapState({
          loading: state => state.loading,
          loadingMessage: state => state.loadingMessage,
          showMessageSnackbar: state => state.messageSnackbar.show,
          messageSnackbar: state => state.messageSnackbar.message,
          showMessageModal: state => state.messageModal.show,
          styleMessageModal: state => state.messageModal.styleMessage,
          titleMessageModal: state => state.messageModal.title,
          messageModal: state => state.messageModal.message,
          parceiro: state => state.parceiro,
          parceiroConfig: state => state.parceiroConfig,
        }),
        getLgpd(){
          return localStorage.getItem('acceptCookies') || localStorage.getItem('refuseCookies')
        },
        getSubdominio(){
            return window.location.host.split('.').length > 2;
        }
    }
  }
</script>

<style lang="scss">
  *{
    box-sizing: border-box !important;
  }
  .loadingBackground{
    position: fixed;
    top: 0;
    left: 0;
    background: var(--blackColor);
    width: 100%;
    height: 100vh;
    z-index: 99999999999999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .loadingBackground img{
    max-width: 250px;
  }

  .loader {
      font-size: 10px;
      margin: 50px auto;
      text-indent: -9999em;
      width: 5em;
      height: 5em;
      border-radius: 50%;
      background: #ffffff;
      background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, .5) 42%);
      background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, .5) 42%);
      background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, .5) 42%);
      background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, .5) 42%);
      background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, .5) 42%);
      position: relative;
      -webkit-animation: load3 1.4s infinite linear;
      animation: load3 1.4s infinite linear;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
  }
  .loader:before {
      width: 50%;
      height: 50%;
      background: #ffffff;
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
  }
  .loader:after {
      background: var(--blackColor);
      width: 75%;
      height: 75%;
      border-radius: 50%;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
  }
  @-webkit-keyframes load3 {
      0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
      }
  }
  @keyframes load3 {
      0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
      }
  }


</style>
